import {Tag} from 'antd';
import {TagProps} from 'antd/es/tag';
import {darken, getLuminance, lighten} from 'polished';
import styled from 'styled-components';

export const StatusTag = styled(Tag)<TagProps>`
  &.ant-tag-has-color,
  &.ant-tag-has-color * {
    color: ${(props) =>
      props.color
        ? getLuminance(props.color) > 0.5
          ? darken(0.5)(props.color)
          : lighten(0.5)(props.color)
        : 'inherit'} !important;
  }

  &.ant-tag-has-color .anticon-close,
  &.ant-tag-has-color .anticon {
    cursor: default;
    transform: scale(0.9) rotate(0deg);
    margin-left: 0;
  }
`;
